module.exports = __webpack_public_path__ + "img/logo.23cc0ce3.svg";